module.exports = __webpack_public_path__ + "static/fonts/FiraSans-BoldItalic.bc94db0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-BoldItalic.ttf
// module id = 1163
// module chunks = 5